export default "__VITE_ASSET__DLfhbf3C__"